'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesAccordion = void 0;
const $ = require("jquery");
class FilesAccordion {
    constructor() {
        this.init();
    }
    init() {
        $(document).on('click', '.trigFilesAccordion', (e) => {
            const $header = $(e.currentTarget);
            const $content = $header.next('.bulletFilesAccordionContent');
            const isOpen = $header.hasClass('is-open');
            if (isOpen) {
                $header.removeClass('is-open');
                $content.stop(true, true).slideUp(200);
            }
            else {
                $header.addClass('is-open');
                $content.stop(true, true).slideDown(200, function () {
                    // slideDown は display:block に固定するため grid に戻す
                    $(this).css('display', 'grid');
                });
            }
        });
    }
}
exports.FilesAccordion = FilesAccordion;
exports.default = FilesAccordion;
